import React, { ReactNode } from 'react'

import { MarginProps } from 'styled-system'

import { Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

type Props = MarginProps & {
  centered?: boolean
  inverse?: boolean
  text: ReactNode
}

function SecondaryHeading({ centered, inverse, text, ...rest }: Props) {
  const { isMobile } = useResponsiveLayout()

  return (
    <Text
      {...rest}
      as="h3"
      bold
      center={centered}
      important={!inverse}
      inverse={inverse}
      screen24={isMobile}
      screen28={!isMobile}
    >
      {text}
    </Text>
  )
}

export default SecondaryHeading
